module.exports = __webpack_public_path__ + "static/media/difficulty-english.ff236fd5.svg";